import Layout, { Section, PageHero } from "@/components/layout/Layout";
import { Reveal } from "@/components/common/Reveal";
import { ArrowUpRight } from "lucide-react";

const papers = [
    { y: "2026", t: "On legible autonomy in agentic systems", a: "Chen, Ramírez, Ito", tag: "Working paper" },
    { y: "2026", t: "Composable evaluation for localized voice models", a: "Adebayo, Nguyen, Silva", tag: "Preprint" },
    { y: "2025", t: "Retrieval as reading: citations for enterprise assistants", a: "Kaur, Weber", tag: "Journal" },
    { y: "2025", t: "Localized voice models for low-resource languages", a: "Adebayo, Chen, Rao", tag: "Conference" },
    { y: "2025", t: "Editorial interfaces for enterprise AI", a: "Weber, Ito", tag: "Essay" },
    { y: "2024", t: "The quiet stack: a reference architecture", a: "Ventara Research", tag: "Technical report" },
];

export default function Research() {
    return (
        <Layout title="Research — Ventara" description="Papers, essays, and technical reports on legible, humane AI.">
            <PageHero i18nKey="research"
                eyebrow="Research"
                title={<>A patient science.</>}
                lead="We publish what we learn. Our research explores the shape of humane AI — legible autonomy, localized voice, and interfaces that respect the reader."
            />

            <Section className="pb-32">
                <div className="border-t border-border">
                    {papers.map((p, i) => (
                        <Reveal key={i}>
                            <a href="#" data-testid={`paper-${i}`}
                               className="grid lg:grid-cols-12 gap-6 py-8 border-b border-border group hover:bg-muted/30 transition-colors -mx-6 sm:-mx-10 px-6 sm:px-10">
                                <div className="lg:col-span-1 label pt-2">{p.y}</div>
                                <div className="lg:col-span-7">
                                    <h3 className="font-serif text-2xl sm:text-3xl tracking-tight">{p.t}</h3>
                                    <p className="prose-body text-sm mt-2">{p.a}</p>
                                </div>
                                <div className="lg:col-span-3 label pt-2">{p.tag}</div>
                                <div className="lg:col-span-1 flex items-start justify-end pt-2">
                                    <ArrowUpRight className="h-5 w-5 text-muted-foreground group-hover:text-foreground transition-colors" />
                                </div>
                            </a>
                        </Reveal>
                    ))}
                </div>
            </Section>
        </Layout>
    );
}
